import { useState, useEffect, useRef } from 'react';
import throttle from 'lodash/throttle';

const OFFSET_DEFAULT = 0;

export function useSticky(initialOffsetTop = null) {
    const [sticky, setSticky] = useState(false);
    const ref = useRef();

    const oldSticky = useRef();

    useEffect(function saveOldSticky() {
        oldSticky.current = sticky;
    });

    useEffect(() => {
        const initialOffset = initialOffsetTop
            ? initialOffsetTop
            : ref.current
            ? ref.current.offsetTop
            : OFFSET_DEFAULT;
        const scrollHandler = throttle(() => {
            const newSticky = window.scrollY > initialOffset;
            if (oldSticky.current !== newSticky) {
                setSticky(newSticky);
            }
        }, 100);
        window.addEventListener('scroll', scrollHandler, false);
        //trigger handler after adding - solves problem with history.back, when "history" page is scrolled
        scrollHandler();
        return () => {
            window.removeEventListener('scroll', scrollHandler, false);
        };
    }, [initialOffsetTop]);
    return [sticky, ref];
}
